import React, { useEffect } from "react";
import { gsap } from "gsap";
import { connect } from "react-redux";
import $ from "jquery";
import { useSkip } from "../../customHooks/customHooks";

import * as actionCreators from "../../store/actions/index";
// import Question from '../Question/Question';

import "./RoleOptions.scss";

const RoleOptions = (props) => {
  let rolesz = [...props.roles];
  const rolePlaceholder = [rolesz[0]];
  rolesz.shift();

  const search = window.location.search; // could be '?foo=bar'
  const params = new URLSearchParams(search);
  const skip = params.get("skip");

  useEffect(() => {
    return () => {
      const roleOptions = $(".role__option").remove().toArray();

      const newRoleOptions = roleOptions.sort((a, b) =>
        $(a).text() > $(b).text() ? 1 : -1
      );

      $(".Role__select").append(newRoleOptions);
    };
  }, [props.currentLang]);

  const roleChangeHandlr = (role) => {
    if (role !== "None") {
      gsap.to(".Nav1--1", {
        opacity: 1,
        pointerEvents: "all",
        duration: 1,
      });
      props.changed(role, props.currentLang);
      localStorage.setItem("currentRole", role);
    } else {
      gsap.to(".Nav1--1", {
        opacity: 0.3,
        pointerEvents: "none",
        duration: 1,
      });
    }
    props.onResetScores(role);

    props.onUpdatePeerScores(role);
//ACC
    document.getElementById('Next_undefined').removeAttribute('disabled')


    $(".Answer__radio").prop("checked", false);
    $(".Answer").css("opacity", "1");
  };

  useEffect(() => {
    onSkipShowSpider();
  }, [props.currentRole, skip]);

  function onSkipShowSpider() {
    if (skip === "true") {
      roleChangeHandlr(props.currentRole);
    }
  }

  return (
    <div className="Role__select--wrapper">
      {/*//ACC*/}
      <select
        className="Role__select"
        id="role"
        name="role"
        onChange={(e) => roleChangeHandlr(e.target.value)}
      >
        {rolePlaceholder.map((role, i) => {
          if (role.English === "Select Your Industry") {
            return (
              <option value="None" key={`role-${i}`}>
                {role[props.currentLang]}
              </option>
            );
          }
          return null;
        })}
        {rolesz.map((role, i) => {
          return (
            <option
              value={role.English}
              key={`role-${i}`}
              className="role__option"
            >
              {role[props.currentLang]}
            </option>
          );
        })}
        ;{/* list.sort((a, b) => (a.color > b.color) ? 1 : -1) */}
      </select>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentLang: state.langReducer.currentLang,
    currentRole: state.roleReducer.currentRole,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onResetScores: (r) => dispatch(actionCreators.reset_scores(r)),
    onUpdatePeerScores: (r) => dispatch(actionCreators.update_peerscore(r)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleOptions);
